export var isNode = false;